/**
 * Drag & Drop Manager — handles template drops into Project/Shot panels
 */
import { projectStore } from '../stores/projectStore';
import { selectionStore } from '../stores/selectionStore';
import { monitorStore } from '../stores/monitorStore';
import { templateRegistry } from './templateRegistry';

export function initDragDrop(): void {
  // Project panel body is the drop target (not just tbody, which is too small when empty)
  const projectPanel = document.querySelector('.project-panel .panel-body') as HTMLElement;
  if (projectPanel) {
    setupDropTarget(projectPanel, handleProjectDrop);
  }

  // Shot launcher drop zone
  const shotBody = document.querySelector('.shot-launcher .panel-body');
  if (shotBody) {
    setupDropTarget(shotBody as HTMLElement, handleShotDrop);
  }
}

function setupDropTarget(el: HTMLElement, onDrop: (templateId: string) => void): void {
  el.addEventListener('dragover', (e) => {
    if (e.dataTransfer?.types.includes('application/x-template-id')) {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
      el.classList.add('drop-hover');
    }
  });

  el.addEventListener('dragleave', (e) => {
    // Only remove if actually leaving the element
    if (!el.contains(e.relatedTarget as Node)) {
      el.classList.remove('drop-hover');
    }
  });

  el.addEventListener('drop', (e) => {
    e.preventDefault();
    el.classList.remove('drop-hover');
    const templateId = e.dataTransfer?.getData('application/x-template-id');
    if (templateId) {
      onDrop(templateId);
    }
  });
}

function handleProjectDrop(templateId: string): void {
  const template = templateRegistry.getTemplate(templateId);
  if (!template) return;

  const item = projectStore.getState().addItem({
    templateId,
    name: template.name,
    fieldValues: templateRegistry.getDefaultFieldValues(templateId),
    duration: template.duration ?? 0,
    isActive: false,
  });

  // Auto-select for preview + properties
  selectionStore.getState().select({ type: 'projectItem', itemId: item.id });
  monitorStore.getState().setPreview(item.id);
}

function handleShotDrop(templateId: string): void {
  // Will be handled in Step 7 (Shot Launcher)
  const template = templateRegistry.getTemplate(templateId);
  if (!template) return;
  // For now, add to project as well
  handleProjectDrop(templateId);
}
